import React from 'react';

import { useIntl } from 'react-intl';

import LightbulbIcon from '@atlaskit/icon/core/lightbulb';
import { token } from '@atlaskit/tokens';

import { AdditionalNoteBase } from './AdditionalNoteBase';
import { messages } from './messages';

export const HighlightLearningField = ({
	highlight,
}: {
	highlight?: { summary: string; description: string };
}): React.JSX.Element => {
	const intl = useIntl();
	return (
		<AdditionalNoteBase
			icon={<LightbulbIcon size="medium" label="" color={token('color.icon.accent.yellow')} />}
			title={highlight?.summary || intl.formatMessage(messages.newLearning)}
			description={highlight?.description}
			testId="project-status-update-action-renderer.ui.highlight-learning"
		/>
	);
};
